export const INITIAL_TOKEN = "877ffe25-8e65-4491-955e-c7b020373321";
// export const BASE_URL = "https://api.famdna.com/";
export const BASE_URL = "https://api.famdna.com/";
export const CSE_ID = 'c5d9966bc91934a18';

export const API_ROUTE = {
  // MARK: USER

  // MARK: QUIZ
  CREATE_QUIZ: "user/quiz",
  JOIN_QUIZ: "user/verify-invitation",
  START_QUIZ: (id) => "user/start-quiz/" + id,
  UPLOAD_ATTACHMENT: "user/upload-attachments",
  GET_QUIZ_LIST: "user/quiz",
  GET_QUIZ_DETAILS: "user/quiz/:id",
  UPDATE_QUIZ_DETAILS: (id = '') => "user/quiz/" + id,
  DELETE_QUIZ: "user/quiz",
  INVITE_QUIZ: "user/quiz-invite",

  // MARK: QUESTION
  GET_QUIZ_QUESTION: (id, page = 1, limit = 10, search = '') => `user/quiz-question?quiz_id=${id}&page=${page}&limit=${limit}&search=${search}`,
  ADD_QUESTION: "user/quiz-question",
  UPDATE_QUESTION: (id) => "user/quiz-question/" + id,
  GET_QUESTION_LIST: "user/quiz-question",
  UPDATE_QUESTION_DETAILS: "user/quiz-question",
  DELETE_QUESTION: "user/quiz-question",
  UPDATE_STATUS: "user/quiz-question",

  // MARK: ANSWER
  GET_LEADERBOARD: "user/get-leaderboard",

  // MARK:QUIZ GAME
  GIVE_ANSWER: "user/audience-question-answer",
  SUBMIT_ANSWER: "user/user-quiz-answer",
  PRESS_BUZZER: "user/press-buzzer",
  GET_USER_LEADERBOARD: (quiz_id) => "user/current-user-rank?quiz_id=" + quiz_id,
  GET_QUIZ_LOBBY_USER: (quiz_id) => "user/quiz-users/" + quiz_id,
  GET_QUIZ_INVITED_USER: (quiz_id) => "user/quiz-invite?quiz_id=" + quiz_id + "&is_paginate=false",
};

